import styled, { css } from 'styled-components';
import { colors, media } from '@prisjakt/ui-base';
import CountryFlagComponent from '@prisjakt/ui-country-flag';

type StockStatusWrapperProps = {
  toneDown: boolean;
  alignCenter: boolean;
};

export const StockStatusWrapper = styled.div<StockStatusWrapperProps>`
  width: 100%;
  flex: 0;
  display: flex;
  flex-direction: row;

  ${props =>
    props.toneDown &&
    css`
      svg path {
        fill: ${colors.lightGray2} !important;
      }
    `}

  ${props =>
    props.alignCenter &&
    css`
      justify-content: center;
    `}
`;

export const HideOnMobile = styled.div`
  ${media.smallOnly`display: none;`}
`;

export const HideOnDesktop = styled.div`
  ${media.mediumUp`display: none;`}
`;

const hidePriceNoticeText = `
  .pj-ui-price-notice {
    margin-right: 0.5rem;
    @media screen and (max-width: 374px) {
      margin-right: 2px;
    }
  }
  .pj-ui-price-notice--text {
    display: none;
  }
`;

type PriceNoticeWrapperProps = {
  hideText: boolean;
};

export const PriceNoticeWrapper = styled.div<PriceNoticeWrapperProps>`
  ${props =>
    props.hideText &&
    css`
      ${hidePriceNoticeText}
    `}
`;

export const CountryFlag = styled(CountryFlagComponent)`
  display: flex;
  flex: 1 0 auto;
`;

export const HomeDeliveryIcon = styled.img`
  height: 20px;
  width: 20px;
  display: block;
`;
